import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import LoginPage from '../routes/LoginPage';
import HomePage from '../routes/HomePage';
import UserLogs from '../routes/UserLogs';
import UserBlacklist from '../routes/UserBlacklist';
import Leaderboard from '../routes/Leaderboard';
import Auth from '../components/Auth';
import Unsubscription from '../routes/Unsubscription';

const Routing = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <LoginPage />
        },
        {
            path:"/home",
            element: <Auth><HomePage /></Auth>
        },
        {
            path:"/user-logs",
            element:<UserLogs />
        },
        {
            path:"/user-blacklist",
            element:<UserBlacklist />
        },
        {
            path:"/leaderboard",
            element:<Leaderboard />
        },
        {
            path:"/unsubscription",
            element:<Unsubscription />
        },
        {
            path:"*",
            element:<Navigate to="/" />
        }
    ])
    return (
        <RouterProvider router={router} />
    )
}

export default Routing